import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { MainLayoutContent } from "~/components/layout/MainLayoutContent";
import MobileNavFooter from "~/components/layout/MobileNavFooter";
import { SidebarProvider } from "~/components/ui/sidebar";
import { supabase } from "~/integrations/supabase/client";
import { UserRole } from "~/types/user";

interface MainLayoutWrapperProps {
  children: React.ReactNode;
  userRole: UserRole;
  pageTitle?: string;
}

export function MainLayoutWrapper({
  children,
  userRole,
}: MainLayoutWrapperProps) {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user has an active session
    const checkSession = async () => {
      const { data } = await supabase.auth.getSession();

      if (!data.session) {
        // No active session found, redirect to login
        navigate("/login", { replace: true });
      }
    };

    checkSession();
  }, [navigate]);

  // Add bottom padding for screens with mobile nav footer (for seller role)
  const contentClass = userRole === "seller" ? "pb-20 md:pb-0" : "";

  return (
    <SidebarProvider>
      <div
        className={`flex min-h-screen w-full overflow-x-hidden ${contentClass} relative`}
      >
        <MainLayoutContent userRole={userRole}>{children}</MainLayoutContent>
        {userRole === "seller" && <MobileNavFooter />}
      </div>
    </SidebarProvider>
  );
}
